import {ListItem} from '../ListItem'
import type {DeploymentsMetadata, RunMetadata} from '@github-ui/repos-rules-types/rules-types'
import {SHORT_SHA_LENGTH} from '../../../../helpers/constants'

export function DeploymentsList({metadata}: {metadata: RunMetadata}) {
  return (
    <ul>
      {(metadata as DeploymentsMetadata).deploymentResults.map(({status, name, sha, id}) => (
        <ListItem
          key={id}
          state={status === 'active' ? 'success' : status}
          title={name}
          description={sha ? `${sha.toString().slice(0, SHORT_SHA_LENGTH)}` : ''}
        />
      ))}
    </ul>
  )
}
